module.exports = __webpack_public_path__ + "img/product_dummy.535dca47.jpg";